
export const handleModal = () => ({
  type: 'TOGGLE_MODAL'
});

export const handleModalHubspot = () => ({
  type: 'TOGGLE_MODAL_HUBSPOT'
});